

import ParallelFields from '@/pages/search/form/parallel/ParallelFields';

import * as PatternStore from '@/store/search/form/patterns';

import SelectPicker from '@/components/SelectPicker.vue';
import MultiValuePicker from '@/components/MultiValuePicker.vue';
import AlignBy from '@/pages/search/form/AlignBy.vue';

export default ParallelFields.extend({
	components: {
		SelectPicker,
		MultiValuePicker,
		AlignBy,
	},
	props: {
		errorNoParallelSourceVersion: { default: false, type: Boolean },
	},
	computed: {
		// The query (or source query, for parallel corpora)
		mainQuery: {
			get(): string { return PatternStore.getState().expert.query || ''; },
			set: (v: string|undefined) => { PatternStore.actions.expert.query(v ?? null) },
		},

		// If this is a parallel corpus: the target queries
		targetQueries: {
			get() { return PatternStore.getState().expert.targetQueries; },
			set: PatternStore.actions.expert.targetQueries,
		},
	},
	methods: {
		changeTargetQuery(index: number, event: Event): void {
			const textarea = event.target as HTMLTextAreaElement;
			PatternStore.actions.expert.changeTargetQuery({index, value: textarea.value});
		},
	}
});
